import { ChainsConfig, IBlockchainEntity } from '@ankr.com/chains-list';

import { AccountingGateway } from '../accounting';
import { IConfig } from '../common';
import { PublicGateway, StandalonePublicGateway } from '../public';
import { RpcGateway } from '../rpc';
import { StatusGateway } from '../status';
import { StatusBlockchainsGateway } from '../status';
import { WorkerGateway } from '../worker';
import { buildPrivateUrls, buildPublicUrls } from './buildUrls';

export class MultiRpcSdk {
  private publicGateway?: PublicGateway;

  private accountingGateway?: AccountingGateway;

  private rpcGateway?: RpcGateway;

  private workerGateway?: WorkerGateway;

  private standalonePublicGateway?: StandalonePublicGateway;

  private statusGateway?: StatusGateway;

  private statusBlockchainsGateway?: StatusBlockchainsGateway;

  public constructor(private readonly config: IConfig) {}

  public getRpcGateway(): RpcGateway {
    this.rpcGateway =
      this.rpcGateway ||
      new RpcGateway({
        baseURL: this.config.publicRpcUrl,
      });

    return this.rpcGateway;
  }

  public getPublicGateway() {
    this.publicGateway =
      this.publicGateway ||
      new PublicGateway({
        workerUrl: this.config.workerUrl,
        accountUrl: this.config.accountUrl,
      });

    return this.publicGateway;
  }

  public getStandalonePublicGateway(baseUrl: string): StandalonePublicGateway {
    this.standalonePublicGateway =
      this.standalonePublicGateway || new StandalonePublicGateway(baseUrl);

    return this.standalonePublicGateway;
  }

  public getWorkerGateway(): WorkerGateway {
    this.workerGateway =
      this.workerGateway ||
      new WorkerGateway({
        baseURL: this.config.workerUrl,
      });

    return this.workerGateway;
  }

  public getAccountingGateway(): AccountingGateway {
    this.accountingGateway =
      this.accountingGateway ||
      new AccountingGateway({
        baseURL: this.config.accountUrl,
      });

    return this.accountingGateway;
  }

  public getStatusGateway(): StatusGateway {
    this.statusGateway = this.statusGateway || new StatusGateway(this.config);

    return this.statusGateway;
  }

  public getStatusBlockchainsGateway(): StatusBlockchainsGateway {
    this.statusBlockchainsGateway =
      this.statusBlockchainsGateway ||
      new StatusBlockchainsGateway(this.config);

    return this.statusBlockchainsGateway;
  }

  public formatPublicEndpoints(blockchains: IBlockchainEntity[]): ChainsConfig {
    const { publicRpcUrl, publicEnterpriseRpcUrl, enterpriseWsUrl } =
      this.config;

    return buildPublicUrls({
      blockchainsApiResponse: blockchains,
      publicRpcUrl,
      publicEnterpriseRpcUrl,
      enterpriseWsUrl,
    });
  }

  public formatPrivateEndpoints(
    blockchains: IBlockchainEntity[],
    userEndpointToken?: string,
  ): ChainsConfig {
    const {
      enterpriseRpcUrl,
      enterpriseWsUrl,
      grpcURL,
      privateRpcUrl,
      privateWsUrl,
    } = this.config;

    return buildPrivateUrls({
      blockchains,
      enterpriseRpcUrl,
      enterpriseWsUrl,
      grpcURL,
      privateRpcUrl,
      privateWsUrl,
      userEndpointToken,
    });
  }
}
